export function memRefundStatusFilter(status) {
  var statusMap = {
    0: '待审核',
    1: '店铺拒绝',
    2: '退款中',
    3: '退款成功',
    4: '用户撤销'
  };
  return statusMap[status];
}